import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

const namespace = 'expreso-el-vasquito';

export default function Footer() {
	return (
		<footer className="content-app">
			<div className={`content-app ${namespace}__footer`}>
        <Link
          to={`/`}
        >
          <img className="logo-footer" src='logo.png' alt='Logo' />
        </Link>
					<div className="navbar-content">
            <a target="_blank" href={`https://ofimovil.net.ar/LOG360/web/VASQUITO/cotizar2`} className="link-menu">Cotizador</a>
            <HashLink className="link-menu" to={`/#retiro`}>Retiro</HashLink>
            <Link
              key={`/recursos-humanos`}
              to={`/recursos-humanos`}
              className="link-menu"
            >rrhh</Link>
					</div>
			</div>
		</footer>
	);

}

